import { render } from "./downloadApp.vue?vue&type=template&id=2cc7b60a&scoped=true"
const script = {}

import "./downloadApp.vue?vue&type=style&index=0&id=2cc7b60a&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc7b60a"]])

export default __exports__